import img1 from "./0603497817283.jpg";
import img1B from "./0603497817283B.jpg";
import img2 from "./5021732549679.jpg";
import img2B from "./5021732549679B.jpg";
import img3 from "./0075678601071.jpg";
import img4 from "./5021732546197.jpg";
import img4B from "./5021732546197B.jpg";
import img7 from "./5021732551757.jpg";
import img8 from "./5021732551764.jpg";
import img9 from "./5021732551771.jpg";
import img10 from "./5021732266965.jpg";
import img10B from "./5021732266965B.jpg";
import img11 from "./5021732526007.jpg";
import img11B from "./5021732526007B.jpg";
import img12 from "./5021732529701.jpg";
import img13 from "./5021732550439.jpg";
import img13B from "./5021732550439B.jpg";
import img14 from "./wa1.jpg";
import img15 from "./5021732526854.jpg";
import img16 from "./5054197899683.jpg";
import img16B from "./5054197899683B.jpg";
import wa3 from "./wa3.jpg";

const covers = [
  {
    ref: [img1, img1B],
    artist: "A-ha",
    title: "Hunting High and Low – The 1984 demos",
    format: "LP - Clear Vinyl",
    description:
      "Version exclusive de l'album High and Low avec des versions démos de chacune des chansons. Nouvel artwork avec des photos inédites. Inclus les démos des tubes Take on me et The Sun always Shines on TV.",
  },
  {
    ref: [img2, img2B],
    artist: "Air",
    title: "Moon Safari - Live & Demos",
    format: "LP - White Vinyl",
    description:
      'Pour la première fois en vinyle une sélection de 10 démos et versions live de l\'ère "Moon Safari". Edition limitée , vinyle blanc.',
  },
  {
    ref: [img16, img16B],
    artist: "Vegyn / Air",
    title: "Blue Moon Safari",
    format: "LP - Blue Vinyl",
    description:
      "L’intemporel album de AIR intégralement revisité par l’un des façonneurs du son d’aujourd’hui. Le producteur britannique Vegyn s’empare avec audace et subtilité de l’héritage et lui confère de nouvelles couleurs, réaffirmant l’inébranlable magie de cet album iconique Edition limitée , vinyle bleu.",
  },
  {
    ref: [img3],
    artist: "Charli XCX",
    title: "Guess",
    format: "45T",
    description: "45T avec le duo Charli XCX / Billie Eilish",
  },
  {
    ref: [wa3, img4B],
    artist: "Charli XCX",
    title: "Number 1 Angel",
    format: "LP - Red vinyl",
    description:
      "La 3ème mixtape de Charli XCX disponible pour la première fois en vinyle.",
  },
  // {
  //   ref: [img7],
  //   artist: "Fred Again...",
  //   title: "Actual Life Piano Live 1",
  //   format: "LP - Magnolia Vinyl",
  //   description:
  //     "Premier volet des Piano Live Sessions enregistrées à Londres. Vinyle de couleur.",
  // },
  // {
  //   ref: [img8],
  //   artist: "Fred Again...",
  //   title: "Actual Life Piano Live 2",
  //   format: "LP - Magnolia Vinyl",
  //   description:
  //     "Deuxième volet des Piano Live Sessions enregistrées à Londres. Vinyle de couleur.",
  // },
  // {
  //   ref: [img9],
  //   artist: "Fred Again...",
  //   title: "Actual Life Piano Live 3",
  //   format: "LP - Magnolia Vinyl",
  //   description:
  //     "Troisième volet des Piano Live Sessions enregistrées à Londres. Vinyle de couleur.",
  // },
  {
    ref: [img10, img10B],
    artist: "Gloria Jones",
    title: "Vixen",
    format: "LP",
    description:
      'Repressage vinyle du 3ème album de Gloria Jones "Vixen". Gloria Jones est notamment connue pour avoir enregistré la version originale de "Tainted Love", chanson de Northern Soul popularisée par le groupe Soft Cell.',
  },
  {
    ref: [img11, img11B],
    artist: "Gorillaz",
    title: "Demon Days Live from the Apollo Theatre",
    format: "2LP - Red Vinyl",
    description:
      'Le Live from the Apollo Theater disponible pour la première fois en vinyle à l\'occasion du 20ème anniversaire de l\'album Demon Days. Enregistré en 2006, on retrouve sur ce live les hits "Feel Good Inc.", "DARE", "Dirty Harry", "Kids with Guns" et "El Mañana".',
  },
  {
    ref: [img12],
    artist: "James Blunt",
    title: "Back to Bedlam : The Demos",
    format: "LP - Red Vinyl",
    description:
      'Compilation de démos enregistrées lors des sessions de l\'enregistrement de l\'album "back to Bedlam". Inclus des versions inédites des titres "You\'re Beautiful", "High" et "Wisemen".',
  },
  {
    ref: [img13, img13B],
    artist: "Liane La Havas",
    title: "Is your Love Big Enough ?",
    format: "LP - Pink & Blue Galaxy Marble Vinyl",
    description:
      'Réédition vinyle de couleur du 1er album de Liane La Havas sorti en 2012. Inclus les singles "No Room for Doubt (feat. Willy Mason)", "Forget" & "Lost & Found".',
  },
  {
    ref: [img14],
    artist: "Morcheeba",
    title: "We Live And Die / Peace Of Me",
    format: '7" orange',
    description:
      "30 ans après le début de leur carrière, les pionniers britanniques du trip hop Morcheeba reviennent avec leur tout premier single 7’’, en exclusivité pour le Disquaire Day. Cette double face A sera disponible en vinyle orange transparent, et présentera « We Live And Die » et « Peace Of Me » (avec le rappeur de Tottenham Oscar #Worldpeace), deux titres qui figureront sur le 11e album studio du groupe, à paraître au printemps 2025.",
  },
  {
    ref: [img15],
    artist: "Rachel Chinouriri",
    title: "Better Off Without",
    format: "MX45T",
    description: "EP sorti en 2022 disponible pour la première fois en vinyle",
  },
];

export default covers;
